import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { SelectModalFieldWithCustom as SelectModalFieldWithCustomElement } from './SelectModalFieldWithCustom';
import type { SelectModalFieldWithCustom as SelectModalFieldWithCustomType } from './types';

const createValidationSchema = (field: SelectModalFieldWithCustomType) => {
  let fieldSchema: ZodTypeAny = z.union([z.string(), z.number(), z.boolean()], {
    required_error: 'Select an option',
  });

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<SelectModalFieldWithCustomType> = {
  FieldComponent: SelectModalFieldWithCustomElement,
  name: 'SelectModalFieldWithCustom',
  createValidationSchema,
};

export default Descriptor;
